// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"d47b5a43","453":"544e15ae","562":"b8d4abd5","619":"592d495a"}[chunkId] + ".chunk.js";
};